import React from "react";
import { Card, CardContent, Typography } from "@mui/material";

const EnvironmentCard = ({ usageData }) => {
  const maxUsers = usageData?.max_users ?? 0;
  const usedUsers = usageData?.total_unique_users ?? 0;
  const remainingUsers = maxUsers - usedUsers;

  console.log("App Usage:", usageData);

  return (
    <Card
      sx={{
        maxHeight: 200,
        m: 1,
        height: 70,
        width: 150,
        borderRadius: 6,
        background: "linear-gradient(90deg, #2196f3 0%, #81a1c14a 8%)",
        color: "black",
        boxShadow: "0 4px 12px rgba(0, 0, 1, 0.15)",
      }}
    >
      <CardContent>
        <Typography sx={{ fontSize: "12px", fontWeight: "bold", color: "#20272F" }} gutterBottom>
          {usageData?.app_name ?? "Sem nome"}
        </Typography>
        <Typography sx={{ fontSize: "12px" }} variant="body1">
          Usuarios: {usedUsers} / {maxUsers}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default EnvironmentCard;
